var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#EBF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9047 18.9413L22.0297 23.0663C22.1815 23.2234 22.2655 23.4339 22.2636 23.6524C22.2617 23.8709 22.1741 24.0799 22.0196 24.2344C21.8651 24.3889 21.6561 24.4766 21.4376 24.4785C21.2191 24.4804 21.0086 24.3964 20.8514 24.2446L16.1372 19.5304C15.981 19.3741 15.8933 19.1622 15.8933 18.9413C15.8933 18.7203 15.981 18.5084 16.1372 18.3521L20.8514 13.6379C21.0086 13.4861 21.2191 13.4021 21.4376 13.404C21.6561 13.4059 21.8651 13.4936 22.0196 13.6481C22.1741 13.8026 22.2617 14.0116 22.2636 14.2301C22.2655 14.4486 22.1815 14.6591 22.0297 14.8163L17.9047 18.9413Z",
    fill: "#2C963D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackicon);
export default __webpack_public_path__ + "static/media/backicon.92417efc6e4fc4bcee4c245a16dce766.svg";
export { ForwardRef as ReactComponent };